export default __webpack_public_path__ + "static/media/logo-background.308f3ac1.jpeg";